import { useMemo, useLayoutEffect, useEffect } from 'react';
import '../../utils/canUseDOM/index.js';
import canUseDOM from '../../utils/canUseDOM/canUseDOM.js';

const useSSRLayoutEffect = function () {
  const effectFunc = useMemo(() => canUseDOM() ? useLayoutEffect : useEffect, []);
  return effectFunc(...arguments);
};

export { useSSRLayoutEffect as default };
